import React, { useRef, useState } from 'react'
import "./contactus.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Headernew from '../landing/headernew/Headernew';
import emailjs from '@emailjs/browser';
import { Modal } from 'react-bootstrap';
const Contactus = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        const templateParams = {
            name: `${firstName} ${lastName}`,
            time: new Date().toLocaleString(),
            email,
            message
        };

        emailjs.send(
            'service_1jfnbjv',
            'template_27g17wh',
            templateParams,
            '0bsaQ34kM5y5nImAo'
        ).then(
            (result) => {
                // alert("Message sent successfully!");
                handleShow();
                setFirstName('');
                setLastName('');
                setEmail('');
                setMessage('');
            },
            (error) => {
                alert("Failed to send message. Please try again.");
                console.error(error.text);
            }
        );
    };

    return (
        <>
            <div id="contactus">
                <section className="main-banner security_main" >
                    <Headernew />
                    <video
                        className="main-banner-video"
                        muted
                        playsInline
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                    >
                        <source src="/assets/bannervideo.mp4" type="video/mp4" />
                    </video>

                    <div className="custom-container1">
                        <div className="top_banner">
                            <motion.h3
                                initial={{ x: -100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: false }} // 👈 animation runs every time on scroll
                                transition={{ duration: 1 }}
                            >
                                Contact Us

                            </motion.h3>
                            <motion.p
                                initial={{ x: -100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: false }} // 👈 animation runs every time on scroll
                                transition={{ duration: 1 }}
                            >
                                <p className='paragraphtexttt'>Boosting Security and IT Operations. We specialize in security assessments, managed IT services, compliance, and cloud solutions tailored to protect and streamline your business with reliable, future-ready strategies.</p>

                            </motion.p>


                        </div>
                    </div>
                </section>
                <div className='contactusmain'>
                    <div className='custom-container1'>
                        <div className='contactus_inner'>
                            <div>

                                <h4><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M19.5679 12.9375C19.3706 12.9003 19.1743 12.8573 18.979 12.8105C18.5686 12.7098 18.1646 12.5849 17.769 12.4365C16.818 12.077 15.7481 12.483 15.2749 13.3828L14.5238 14.8252C13.414 14.1951 12.3946 13.4175 11.4936 12.5137C10.5925 11.6092 9.81755 10.5873 9.18986 9.47557L10.6235 8.72948C11.5233 8.25615 11.9294 7.18651 11.5703 6.23533C11.4214 5.83916 11.2964 5.43449 11.1958 5.02342C11.1481 4.82841 11.1059 4.63182 11.0693 4.43358C10.7982 3.01536 9.55418 1.99223 8.11033 1.99998H5.03465C4.14897 1.99992 3.30742 2.38658 2.73045 3.05858C2.15873 3.72081 1.90446 4.59959 2.03416 5.46483C3.36583 13.967 10.0323 20.6382 18.5337 21.9756C18.6817 21.9981 18.8312 22.0095 18.9809 22.0097C19.7005 22.0089 20.3959 21.7501 20.9409 21.2803C21.6135 20.703 22.0005 19.8609 22.0005 18.9746V15.8965C22.0087 14.4527 20.9859 13.2086 19.5679 12.9375ZM21.0005 18.9746C21.0002 19.5694 20.7402 20.1344 20.2886 20.5215C19.8468 20.9024 19.2612 21.0725 18.6841 20.9873C10.6151 19.7179 4.28746 13.3862 3.02342 5.31639C2.93681 4.739 3.10679 4.15251 3.48875 3.71092C3.87553 3.25957 4.44029 2.99986 5.03465 2.99998H8.11033C9.072 2.99223 9.90245 3.67119 10.086 4.61522C10.1255 4.83104 10.1724 5.04686 10.2242 5.26072C10.3346 5.71049 10.4715 6.1533 10.6343 6.5869C10.816 7.06492 10.6131 7.60344 10.1612 7.84276L8.27739 8.82323C8.03264 8.95061 7.93736 9.25218 8.0645 9.49705C8.77623 10.8692 9.69389 12.1244 10.7856 13.2187C11.8768 14.3142 13.1297 15.2358 14.5005 15.9512C14.6186 16.0113 14.7555 16.0232 14.8822 15.9844C15.0086 15.9447 15.1139 15.8566 15.1753 15.7392L16.1616 13.8447C16.401 13.3934 16.9388 13.1908 17.4165 13.3721C17.8496 13.535 18.2921 13.6717 18.7417 13.7812C18.9536 13.834 19.1675 13.8789 19.3843 13.9199C20.3288 14.1034 21.0082 14.9343 21.0005 15.8965V18.9746Z" fill="#180047" />
                                </svg> <a style={{ color: "#5C5172" }} href="tel: +1 302 560 7295">+1 302 560 7295</a></h4>
                                <h4><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M22 7L13.009 12.727C12.7039 12.9042 12.3573 12.9976 12.0045 12.9976C11.6517 12.9976 11.3051 12.9042 11 12.727L2 7" stroke="#180047" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z" stroke="#180047" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>  <a style={{ color: "#5C5172" }} href="mailto: info@techsecure360.com">info@techsecure360.com</a></h4>
                                {/* <h4><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12.1124 2.00111C7.69415 1.93898 4.06207 5.47041 4 9.88869C4 15.3369 11.3643 21.6172 11.6777 21.8818C11.7677 21.9583 11.882 22.0002 12 22C12.118 22.0002 12.2323 21.9583 12.3223 21.8818C12.6357 21.6172 20 15.3369 20 9.88869C19.9391 5.55794 16.4432 2.06196 12.1124 2.00111ZM12 20.834C10.584 19.5625 5 14.2666 5 9.88869C5.03534 6.05537 8.16663 2.97389 12 3.00001C15.8334 2.97389 18.9647 6.05537 19 9.88869C19 14.2627 13.415 19.5615 12 20.834ZM12 7.00001C10.3431 7.00001 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6561 12.9982 14.9982 11.6561 15 10C15 8.34315 13.6569 7.00001 12 7.00001ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89546 10.8954 8.00001 12 8.00001C13.104 8.00142 13.9986 8.89601 14 10C14 11.1046 13.1046 12 12 12Z" fill="#180047" />
                                </svg> 470 Rodao Dr SW,Liburn, GA 4854562</h4> */}
                            </div>
                            <div>
                                <form onSubmit={sendEmail} ref={formRef}>
                                    <div className='top_one'>
                                        <div className='inputttdiv'>
                                            <h5>First Name</h5>
                                            <input
                                                type="text"
                                                placeholder='Enter your first name'
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className='inputttdiv'>
                                            <h5>Last Name</h5>
                                            <input
                                                type="text"
                                                placeholder='Enter your last name'
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='inputttdiv lassst_Div'>
                                        <h5>Email</h5>
                                        <input
                                            type="email"
                                            placeholder='Enter your email'
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className='inputttdiv'>
                                        <h5>Message</h5>
                                        <textarea
                                            rows="8"
                                            cols="50"
                                            placeholder='Enter your message'
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button type="submit">Send</button>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <Modal className='modalsecure' show={show} onHide={handleClose} centered>
                <Modal.Header >
                    <Modal.Title>Form Submit  <svg onClick={handleClose} className="svcg" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M18 6.5L6 18.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 6.5L18 18.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="textual_div">
                        <img src="\assets\emailicon.svg" className="imgggsize" />
                        <h3>Thank you for reaching out!
                        </h3>
                        <h4>Someone from our team will get in touch with you shortly</h4>
                    </div>
                </Modal.Body>

            </Modal>

        </>
    )
}

export default Contactus
